export const getDefaultRoofForSeason = (Season) => {
  switch (Season) {
    case "OPTIMAL":
      return "ROOF_10";
    case "ISOLENT":
      return "ROOF_32";
    case "ISOMAX":
      return "ROOF_50";
    default:
      console.error(
        `Unexpected value '${Season}' for Season in getDefaultRoofForSeason`
      );
      return "";
  }
};
